import { useTranslation } from 'react-i18next';
import { enUS, esES, Localization } from '@mui/material/locale';
import i18n from '~/locales/i18n';

type LanguageType = {
  label: string;
  systemValue: Localization;
  value: string;
  baseCode: string;
};

const LANGUAGE_OPTIONS: Record<string, string> = {
  en_US: 'English',
  es_ES: 'Español'
};

// Function to dynamically generate the LANGUAGES array based on i18n resources
const generateLanguageOptions = (): Array<LanguageType> => {
  const availableLanguages = Object.keys(i18n.options.resources || {});

  const defaultSystemValues: Record<string, Localization> = {
    en: enUS,
    es: esES
  };

  return availableLanguages.map((langCode) => {
    const baseCode = langCode.split('_')[0];
    return {
      label: LANGUAGE_OPTIONS[langCode] || langCode,
      baseCode,
      value: langCode,
      systemValue: defaultSystemValues[baseCode] || enUS
    };
  });
};

export const LANGUAGES: Array<LanguageType> = generateLanguageOptions();

// Function to get available languages (for debugging)
export function getAvailableLanguages() {
  return Object.keys(i18n.options.resources || {});
}

export function getLanguage(locale: string) {
  return LANGUAGES.find(({ value }) => value === locale) || LANGUAGES[0];
}

export default function useLocales() {
  const { t } = useTranslation();
  const changeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
  };

  return {
    changeLanguage,
    t,
    i18n
  };
}
